<template>
  <div class="calico-pagination-tab">
    <span 
      class="link" 
      :class="{ disabled, selected: isSelected }"
      tabindex="0"
      @click="select"
      @keydown.enter="select"
      @keydown.space.prevent="select"
    >
      <slot />
    </span>
  </div>
</template>

<script>
export default {
  name: "CalicoNavigationTab",
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    page: {
      type: [String, Number],
      default: ''
    },
  },
  computed: {
    isSelected() {
      const current = this.$route.query.page;
      return String(current || '') === String(this.page || '');
    },
  },
  methods: {
    async select() {
      if (this.page) {
        const routeUpdate = {
          query: {
            ...this.$route.query,
            page: this.page,
          },
          hash: this.$route.hash 
        };

        await this.$router.push(routeUpdate);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.calico-pagination-tab {
  .link {
    @include inset-space($space-xsmall);
    @include inline-space($space-none);
    background-color: $color-transparent;
    color: $color-black;
    border-radius: $radius-small;
    box-sizing: border-box;
    outline: none;

    text-decoration: none;
    user-select: none;

    &:hover:not(.selected) {
      background-color: $color-neutral-light;
      color: $color-black;
    }

    &:focus-visible:not(.selected) {
      border: 2px solid $color-black;
      @include inset-space($space-xsmall - 2px);
    }

    &:active {
      color: $color-black !important;
      background-color: $color-neutral !important;
    }

    &.disabled {
      display: none;
    }

    &.selected {
      color: $color-white;
      background-color: $color-pink-dark;
    }
  }
}
</style>